import React from "react";
import { Timer } from "./features/timer/Timer";
import { Text } from "./features/text/Text";
import { Dashboard } from "./features/dashboard/Dashboard";
import { SessionTimeline } from "./features/sessionTimeline/SessionTimeline";
import { LucketSelector } from "./features/lucketSelector/LucketSelector";
import { ActiveLucketManager } from "./features/activeLucketManager/ActiveLucketManager";
import { SessionAnalysis } from "./features/sessionAnalysis/SessionAnalysis";
import MindMap2 from "../../../mind-2/MindMap2";
import './sessionWatch.css'
import { useSelector, useDispatch } from "react-redux";
import { selectTimerStatus, selectMindMapOpen, toggleMindMap, selectRiskRegisterOpen, toggleRiskRegister } from "./sessionWatchSlice";
import { TIMER_STATUS } from "./constants";
import { TimerStatus } from "./features/timer/TimerStatus";
import { RiskRegister } from "../../../riskRegister/riskRegister";

export const SessionWatch = () => {
    const timerStatus = useSelector(selectTimerStatus);
    const mindMapOpen = useSelector(selectMindMapOpen);
    const riskRegisterOpen = useSelector(selectRiskRegisterOpen);
    const dispatch = useDispatch();

    const handleToggleMindMap = () => {
        dispatch(toggleMindMap());
    };

    const handleToggleRiskRegister = () => {
        dispatch(toggleRiskRegister());
    };

    return <div id={"sessionWatchBody"}>
        <div id={"sessionWatchBodyLeftSide"}>
            <TimerStatus />

            {/* Show lucket selector when stopped */}
            {timerStatus === TIMER_STATUS[0] && (
                <div id="lucketSelector">
                    <LucketSelector />
                </div>
            )}

            <div id="timer">
                <Timer />
            </div>

            {/* Mind Map toggle button - show when timer is running */}
            {timerStatus === TIMER_STATUS[1] && (
                <button
                    onClick={handleToggleMindMap}
                    className="mindmap-toggle-btn"
                    style={{
                        marginTop: '10px',
                        padding: '10px 20px',
                        backgroundColor: mindMapOpen ? '#753bbd' : '#e8eaec',
                        color: mindMapOpen ? 'white' : '#333',
                        border: '2px solid #753bbd',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        width: '90%',
                        transition: 'all 0.2s'
                    }}
                >
                    {mindMapOpen ? '📝 Show Dashboard' : '🧠 Mind Map'}
                </button>
            )}

            {/* Risk Register toggle button - show when timer is running */}
            {timerStatus === TIMER_STATUS[1] && (
                <button
                    onClick={handleToggleRiskRegister}
                    className="riskregister-toggle-btn"
                    style={{
                        marginTop: '10px',
                        padding: '10px 20px',
                        backgroundColor: riskRegisterOpen ? '#dc3545' : '#e8eaec',
                        color: riskRegisterOpen ? 'white' : '#333',
                        border: '2px solid #dc3545',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        width: '90%',
                        transition: 'all 0.2s'
                    }}
                >
                    {riskRegisterOpen ? '📝 Show Dashboard' : '⚠️ Risk Register'}
                </button>
            )}

            {/* Show compact session analysis when running */}
            {timerStatus === TIMER_STATUS[1] && (
                <div id="compactSessionAnalysis">
                    <SessionAnalysis compact={true} />
                </div>
            )}
        </div>
        <div id={"sessionWatchBodyRightSide"}>
            {/* Show mind map if open and timer is running */}
            {timerStatus === TIMER_STATUS[1] && mindMapOpen && (
                <div style={{ height: '100%', overflow: 'hidden' }}>
                    <MindMap2 />
                </div>
            )}

            {/* Show risk register if open and timer is running */}
            {timerStatus === TIMER_STATUS[1] && riskRegisterOpen && (
                <div style={{ height: '100%', overflow: 'auto', padding: '20px' }}>
                    <RiskRegister />
                </div>
            )}

            {/* Show normal session content when mind map and risk register are closed */}
            {timerStatus === TIMER_STATUS[1] && !mindMapOpen && !riskRegisterOpen && (
                <>
                    {/* Show active lucket manager during session */}
                    <div id="activeLucketManager">
                        <ActiveLucketManager />
                    </div>
                    <Text />
                </>
            )}

            {/* Always show dashboard when timer is stopped */}
            {timerStatus === TIMER_STATUS[0] && <Dashboard />}
        </div>
    </div>;
}


